// This file is used for Classic's header menu.
export default {};
